<div class="sm:py-12 sm:bg-gray-50">
	<div class="container">
		<div
			class="grid grid-cols-1 sm:border sm:rounded-md sm:grid-cols-4 xl:grid-cols-5"
		>
			<div class="h-full bg-white sm:col-span-2 xl:col-span-3">
				@if (uniGallery()) {
					<uc-university-gallery
						ngSkipHydration
						[gallery]="mappedGallery"
						[coverImage]="coverImage"
						[isFeatured]="isFeaturedGallery()"
						[id]="id()"
						[saved]="saved()"
						[delta]="delta()"
						[ugSearchOrderPosition]="ugSearchOrderPosition()"
						[uniName]="uniName()"
						[product]="product()"
						[courseSlug]="courseSlug()"
						[academicYear]="academicYear()"
						[cleSearchOrderPosition]="cleSearchOrderPosition()"
					/>
				}
			</div>
			<div class="flex pt-4" *ucRemoveDuplicateDomElement="'hideOnDesktop'">
				<!-- University or Course name -->
				<ng-content select="[headerTitle]" />
			</div>
			<div class="sm:col-span-2">
				<uc-cta-container [uniSliderCopy]="uniSliderCopy()" [tab]="tab()">
					<!-- CTA slot -->
					<ng-content />
				</uc-cta-container>
			</div>
		</div>
	</div>
</div>
